export enum ETableSortColumn {
  NAME = 'fullName',
  TYPE = 'contactType',
  EMAIL = 'email',
  ROLE = 'role',
  CREATED = 'createdDate',
  PUBLISHED = 'publishedDate',
}
